import AuthenticatedGate from "./AuthenticatedGate";

export default AuthenticatedGate;
